import { apiClient } from './client';
import type { User } from '../types';

export interface CreateUserData {
  username: string;
  password: string;
  role: 'admin' | 'user';
}

export interface ResetPasswordData {
  new_password: string;
}

export async function listUsers(): Promise<User[]> {
  const { data } = await apiClient.get<User[]>('/admin/users');
  return data;
}

export async function createUser(userData: CreateUserData): Promise<User> {
  const { data } = await apiClient.post<User>('/admin/users', userData);
  return data;
}

export async function deleteUser(userId: number): Promise<void> {
  await apiClient.delete(`/admin/users/${userId}`);
}

export async function resetPassword(userId: number, passwordData: ResetPasswordData): Promise<{ ok: boolean }> {
  const { data } = await apiClient.post<{ ok: boolean }>(`/admin/users/${userId}/reset-password`, passwordData);
  return data;
}
